"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = loadScript;

var _heliotropeError = _interopRequireWildcard(require("./heliotropeError"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

var windowWithSegmentGlobals = window;

function loadScript(_x) {
  return _loadScript.apply(this, arguments);
}

function _loadScript() {
  _loadScript = _asyncToGenerator(function* (writeKey) {
    // Create a queue, but don't obliterate an existing one!
    windowWithSegmentGlobals.analytics = windowWithSegmentGlobals.analytics || [];
    var analytics = windowWithSegmentGlobals.analytics; // If the real analytics.js is already on the page return.

    if (analytics.initialize) {
      return;
    } // Segment IO Documentation - If the snippet was invoked already show an error.
    // I believe the difference between 'invoked' and 'initialize' is that 'invoked' will 
    // disappear after everything is loaded. Therefore, I believe that this is checking
    // if this function has been called AND analytics.js hasn't completed loading yet


    if (analytics.invoked) {
      var invokedErrorMessage = 'Segment snippet was invoked again, before the Segment tag finished loading from it\'s first invocation.';

      if (windowWithSegmentGlobals.console && console.error) {
        console.error("".concat(_heliotropeError.errorPrefix).concat(invokedErrorMessage));
      }

      throw (0, _heliotropeError.default)(invokedErrorMessage);
    } // Invoked flag, to make sure the snippet
    // is never invoked twice.


    analytics.invoked = true; // A list of the methods in Analytics.js to stub.

    analytics.methods = ['identify', 'track', 'alias', 'page', 'trackSubmit', 'trackClick', 'trackLink', 'trackForm', 'pageview', 'reset', 'group', 'ready', 'debug', 'once', 'off', 'on', 'addSourceMiddleware', 'addIntegrationMiddleware', 'setAnonymousId', 'addDestinationMiddleware']; // Define a factory to create stubs. These are placeholders
    // for methods in Analytics.js so that you never have to wait
    // for it to load to actually record data. The `method` is
    // stored as the first argument, so we can replay the data.

    analytics.factory = function (method) {
      return function () {
        var args = Array.prototype.slice.call(arguments);
        args.unshift(method);
        analytics.push(args);
        return analytics;
      };
    }; // For each of our methods, generate a queueing stub.


    for (var i = 0; i < analytics.methods.length; i = i + 1) {
      var _key = analytics.methods[i];
      analytics[_key] = analytics.factory(_key);
    } // Define a method to load Analytics.js from our CDN,
    // and that will be sure to only ever load it once.


    analytics.load = function (key, options) {
      var _first$parentNode;

      // Create an async script element based on your key.
      var script = document.createElement('script');
      script.type = 'text/javascript';
      script.async = true;
      script.src = "https://cdn.segment.com/analytics.js/v1/".concat(key, "/analytics.min.js"); // Insert our script next to the first script element.

      var first = document.getElementsByTagName('script')[0];
      (_first$parentNode = first.parentNode) === null || _first$parentNode === void 0 ? void 0 : _first$parentNode.insertBefore(script, first);
      analytics._loadOptions = options;
    }; // Add a version to keep track of what's in the wild.


    analytics.SNIPPET_VERSION = '4.1.0'; // Load Analytics.js with your key, which will automatically
    // load the tools you've enabled for your account. Boosh!

    analytics.load(writeKey);
    return new Promise((resolve, reject) => {
      var interval = setInterval(() => {
        if (interval && window.analytics.ready) {
          window.analytics.ready(resolve);
          clearInterval(interval);
          interval = null;
        }
      }, 50);
      setTimeout(() => {
        if (interval) {
          clearInterval(interval);
          interval = null;
          reject((0, _heliotropeError.default)('Error loading Segment library via Heliotrope: window.analytics.ready not found'));
        }
      }, 10000);
    });
  });
  return _loadScript.apply(this, arguments);
}
//# sourceMappingURL=loadScript.js.map